import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu-mas-consultados',
  templateUrl: './menu-mas-consultados.component.html',
  styleUrls: ['./menu-mas-consultados.component.css']
})
export class MenuMasConsultadosComponent {

  constructor(private router: Router) {
  }

  public openMasConsultados(id: string, titulo: string, subtitulo: string) {
    this.router.navigate(['informacionSerie/', id, titulo, subtitulo]);
  }

  public openVideoGuia(){
    window.open('https://www.youtube.com/@BancoRepublica', '_blank');
  }

}
